import React from 'react';
import icLoading from '../../../../asset/login/loading.png';
import './index.less';
export function BtnSave(_ref) {
  var onConfirm = _ref.onConfirm,
    isSaving = _ref.isSaving,
    confirmDisabled = _ref.confirmDisabled;
  return /*#__PURE__*/React.createElement("div", {
    className: "login-personal-btn-save-wrap"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return !confirmDisabled && !isSaving && onConfirm && onConfirm();
    },
    style: isSaving ? {
      cursor: 'not-allowed'
    } : {},
    className: "login-btn-primary ".concat(confirmDisabled ? 'disabled' : '')
  }, isSaving ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    className: "login-personal-btn-save-loading",
    src: icLoading,
    alt: ""
  }), "\u4FDD\u5B58\u4E2D") : '保存'));
}